//@ts-check
import '@/common/index';
import './style.css';
import { component, install } from 'riot';
import store from './store';
import 'tocca';
import App from './app/app';
import { registerStore } from '@/common/lib/riot-redux';
import { cssPlugin, helperPlugin } from '@/common/lib/riot-plugins';
import { appInit, userInit } from './app/app.action';
import { router, setBase } from '@riotjs/route';
import { ajaxPost, errorHandler } from './ajax';
import { loginFailure, loginSuccess } from './login/login.action';
import storage from '@/common/storage';

registerStore(store);
const main = async () => {
  if (location.hash === '') {
    location.replace('/point/#');
  }
  if (location.hash === '') {
    location.replace('/point/#');
  }
  const [shopId] = location.hash.replace('#', '').replace(/\?(.*)/g, '').split('/');
  const phone = storage.getItem('phone');
  const shop = storage.getItem('shopId');
  const password = storage.getItem('password');
  if (shopId === 'user' && phone && shop && password) {
    try {
      const res = await ajaxPost('/point', {
        method: 'login',
        shopId: shop,
        phone,
        password
      });
      store.dispatch(loginSuccess(res));
      const data = await ajaxPost('/point', {
        method: 'init',
        shopId: shop,
      });
      const web = data.web;
      const validId = true;
      const shopId = shop;
      store.dispatch(userInit({ web, validId, shopId }));
      router.push('user');
      // @ts-ignore
      component(App)(document.getElementById('root'));
    } catch (e) {
      store.dispatch(loginFailure(e));
      // @ts-ignore
      component(App)(document.getElementById('root'));
    }
  } else if (shopId == 'user' && shop) {
    location.href = `/point/#${shop}`;
  } else {
    install(cssPlugin());
    install(helperPlugin());
    setBase(`#${shopId}/`);
    try {
      const data = await ajaxPost('/point', {
        method: 'init',
        shopId,
      });
      const web = data.web;
      const validId = true;
      store.dispatch(appInit({ shopId, web, validId }));
      // @ts-ignore
      component(App)(document.getElementById('root'));
    } catch (e) {
      errorHandler(e);
      const validId = false;
      store.dispatch(appInit({ shopId, validId }));
      // @ts-ignore
      component(App)(document.getElementById('root'));
    }
  }
};

window.addEventListener('load', main);